import Head from 'next/head';
import { PAGE_TITLE, PAGE_DESCRIPTION } from '../../constants';

const MetaTags = (props: any) => {
  const title = props.title || PAGE_TITLE;
  const description = props.description || PAGE_DESCRIPTION;
  return (
    <Head>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="author" content="ClearTax" />
      <meta
        name="copyright"
        content="Defmacro Software Pvt. Ltd. Copyright (c) 2018"
      />
      <meta
        name="keywords"
        content="mutual funds, MF Investment India, investing in mutual funds, top mutual funds, best mutual funds, sip calculator, tax saving mutual funds, elss,sip,online mutual funds investment"
      />
      <meta name="description" content={description} />
      <meta
        name="google-site-verification"
        content="QRKBEdtz1fiPAGB6su7gSD9W9Bf2XnHN2VOGKgrETWE"
      />

      <meta name="twitter:app:id:googleplay" content="in.cleartax.cleartax" />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image:secure_url"
        content="https://assets1.cleartax-cdn.com/clearsave-frontend/images/OG-images-01.png"
      />
      <meta property="og:url" content="https://cleartax.in/save" />
      <meta
        property="og:image"
        content="https://assets1.cleartax-cdn.com/clearsave-frontend/images/OG-images-01.png"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@ClearTax_In" />
      <meta name="twitter:domain" content="https://cleartax.in" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image:src"
        content="https://assets1.cleartax-cdn.com/clearsave/og_image_clearsave.png"
      />
      {props.noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : null}
    </Head>
  );
};

export default MetaTags;



// WEBPACK FOOTER //
// ./components/header/metaTags.tsx